"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNaturalNumber = exports.isNullOrUndefined = void 0;
/**
 * Gets whether the value provided is null or undefined.
 * @param value The value to check.
 * @returns Whether the value provided is null or undefined.
 */
function isNullOrUndefined(value) {
    return value === null || value === undefined;
}
exports.isNullOrUndefined = isNullOrUndefined;
/**
 * Gets whether the value provided is a natural number.
 * @param value The value to check.
 * @returns Whether the value provided is a natural number.
 */
function isNaturalNumber(value) {
    return typeof value === "number" && value >= 1 && Math.floor(value) === value;
}
exports.isNaturalNumber = isNaturalNumber;
